import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./lowertopbar.css";
import lafemalogo from "..//..//..//images/lafemalogo.png";
import { FiAlignJustify, FiXCircle } from "react-icons/fi";

function Lowertopbar() {
  const [click, setClick] = useState(false);
  //const [isResponsiveclose, setResponsiveclose] = useState(false);

  const handleClick = () => {
    setClick(click === false ? true : false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <NavLink exact to="/" className="nav-logo1">
          <img src={lafemalogo} alt="" />
          <h2>LAFEMA SYSTEMS</h2>

          <div
            className={click ? "fas fa-times" : "fas fa-bars"}
            onClick={handleClick}
          >
            {click === true ? (
              <>
                <span
                  className="menubar__button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick();
                  }}
                >
                  <FiXCircle className="cancel" />
                </span>
              </>
            ) : (
              <>
                <span
                  className="menubar__button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick();
                  }}
                >
                  <FiAlignJustify className="cancel" />
                </span>
              </>
            )}
          </div>
        </NavLink>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <div className="zilezachini">
            <li className="nav-item">
              <NavLink
                exact
                to="/account"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ACCOUNT
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                HOME
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                exact
                to="/services"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                SERVICES
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/products"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                PRODUCTS
              </NavLink>
            </li>
          </div>

          <div className="zilezajuu">
            <li className="nav-item">
              <NavLink
                exact
                to="/services"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                SERVICES
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/whyus"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                WHY US
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/contactus"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                CONTACT
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/aboutus"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                ABOUTUS
              </NavLink>
            </li>
          </div>
        </ul>
      </div>
    </nav>
  );
}

export default Lowertopbar;
